import { connect } from 'react-redux';
import { Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { withChartLayout } from 'components/common';
import OBTriage from 'components/features/chart/special-charts/ob-triage/OBTriage';

const OBTriageContent = withChartLayout('OB Triage')(OBTriage);

export interface OBTriagePageProps {
  isSimulationEHREnabled: boolean;
  locale: Locales;
}

export const BaseOBTriagePage = ({ isSimulationEHREnabled, locale }: OBTriagePageProps) =>
  isSimulationEHREnabled && locale !== Locales.EN_AU ? <OBTriageContent /> : null;

const mapStateToProps = (state) => ({
  isSimulationEHREnabled: appSelectors.getIsSimulationEHREnabled(state),
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(BaseOBTriagePage);
